import {createTheme} from '@mui/material/styles';
import {blueGrey, grey, lightBlue, red} from '@mui/material/colors';


export const THEME = createTheme({
    typography: {
        useNextVariants: true
    },
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: lightBlue[900],
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            // light: will be calculated from palette.primary.main,
            main: blueGrey[500],
            // dark: will be calculated from palette.secondary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
    },
    custom:{
        paper:{
            side_space: 30,
            top_space: 20,
            bottom_space: 30,
        },
        font: {
            bold: 500,
            light: 200,
            line_height: 1.5,
            small: 12,
            medium: 14,
            large: 16
        },
        color:{
            error: red[500],
            grey: grey[600]
        },
        min_width: 1300,
        spacing: {
            default: 24
        }
    },
    components: {
        MuiBadge: {
            defaultProps: {
                overlap: "rectangular"
            },
        }
    },
});